<template>
  <div class="page">
    <HeroCarousel />
    <ProductCategorySection
      v-model="selectedCategoryId"
      :navigate-on-click="true"
    />

    <!-- Popular -->
    <section class="popular-section" id="popular">
      <div class="popular-inner">
        <div class="popular-head">
          <span class="popular-hot-icon" aria-hidden="true">
          <img src="@/assets/hot.png" alt="HOT" class="popular-hot-icon-img" />
          </span>
          <h2 class="popular-title">{{ $t('home.popularTitle') }}</h2>
        </div>
        <div class="popular-line-wrap">
          <div class="popular-accent-line" />
          <div class="popular-rule-line" />
        </div>
       

        <div class="popular-grid">
          <button
            type="button"
            class="popular-card"
            :class="{ 'popular-card--selected': selectedPopularId === '1' }"
            @click="selectedPopular('1')"
          >
            <div class="popular-card-img-wrap">
              <img
                :src="require('@/assets/popular1.png')"
                :alt="$t('home.popular.p1')"
                class="popular-card-img"
              />
            </div>
            <div class="popular-card-label">{{ $t('home.popular.p1') }}</div>
          </button>
          <button
            type="button"
            class="popular-card"
            :class="{ 'popular-card--selected': selectedPopularId === '2' }"
            @click="selectedPopular('2')"
          >
            <div class="popular-card-img-wrap">
              <img
                :src="require('@/assets/popular2.png')"
                :alt="$t('home.popular.p2')"
                class="popular-card-img"
              />
            </div>
            <div class="popular-card-label">{{ $t('home.popular.p2') }}</div>
          </button>
          <button
            type="button"
            class="popular-card"
            :class="{ 'popular-card--selected': selectedPopularId === '3' }"
            @click="selectedPopular('3')"
          >
            <div class="popular-card-img-wrap">
              <img
                :src="require('@/assets/popular3.png')"
                :alt="$t('home.popular.p3')"
                class="popular-card-img"
              />
            </div>
            <div class="popular-card-label">{{ $t('home.popular.p3') }}</div>
          </button>
          <button
            type="button"
            class="popular-card"
            :class="{ 'popular-card--selected': selectedPopularId === '4' }"
            @click="selectedPopular('4')"
          >
            <div class="popular-card-img-wrap">
              <img
                :src="require('@/assets/popular4.png')"
                :alt="$t('home.popular.p4')"
                class="popular-card-img"
              />
            </div>
            <div class="popular-card-label">{{ $t('home.popular.p4') }}</div>
          </button>
        </div>
      </div>
    </section>

    <!-- About：外 1920 内 1570，单屏左文右图 -->
    <section class="about-section" id="about">
      <div class="about-outer">
        <div class="about-inner">
          <header class="about-header">
            <h2 class="about-heading">{{ $t('home.aboutTitle') }}</h2>
            <div class="about-title-rule" aria-hidden="true">
              <span class="about-title-rule-blue" />
              <span class="about-title-rule-gray" />
            </div>
          </header>

          <div class="about-main">
            <div class="about-text">
              <p class="about-p" v-html="$t('home.about1_html')"></p>
               
            </div>
            <div class="about-figure">
              <img :src="require('@/assets/about1-1.png')" alt="" class="about-block-img" />
            </div>
          </div>
          <div class="about-bottom-rule" aria-hidden="true">
            <span class="about-bottom-rule-blue" />
            <span class="about-bottom-rule-white" />
          </div>

        </div>
      </div>
    </section>

    <!-- About B-end：白底、左图右文，外 1920 内 1570 -->
    <section class="about-b2-section" id="about-b2">
      <div class="about-b2-outer">
        <div class="about-b2-inner">
          <div class="about-b2-main">
            <div class="about-b2-figure">
              <img
                :src="require('@/assets/about1-2.png')"
                alt=""
                class="about-b2-img"
              />
            </div>
            <div class="about-b2-text">
              <p class="about-b2-p" v-html="$t('home.about2_html')" />
            </div>
          </div>
          <div class="about-bottom-rule" aria-hidden="true">
            <span class="about-bottom-rule-blue" />
            <span class="about-bottom-rule-gray" />
          </div>
        </div>
      </div>
    </section>

    <section class="about-section" id="about">
      <div class="about-outer">
        <div class="about-inner">
          <div class="about-main">
            <div class="about-text">
              <p class="about-p" v-html="$t('home.about3_html')"></p>
            </div>
            <div class="about-figure">
              <img :src="require('@/assets/about1-3.png')" alt="" class="about-block-img" />
            </div>
          </div>
          <div class="about-bottom-rule" aria-hidden="true">
            <span class="about-bottom-rule-blue" />
            <span class="about-bottom-rule-white" />
          </div>

        </div>
      </div>
    </section>
    <section class="about-b2-section" id="about-b2">
      <div class="about-b2-outer">
        <div class="about-b2-inner">
          <div class="about-b2-main">
            <div class="about-b2-figure">
              <img
                :src="require('@/assets/about1-4.png')"
                alt=""
                class="about-b2-img"
              />
            </div>
            <div class="about-b2-text">
              <p class="about-b2-p" v-html="$t('home.about4_html')" />
            </div>
          </div>
          <div class="about-bottom-rule" aria-hidden="true">
            <span class="about-bottom-rule-blue" />
            <span class="about-bottom-rule-gray" />
          </div>
        </div>
      </div>
    </section>
    <!-- CONTACT：背景 1920，卡片 1570，人物 552×528 -->
    <footer class="contact-footer" id="contact">
      <div class="contact-footer-bg">
        <img :src="require('@/assets/contact.png')" alt="" class="contact-bg-img" />
      </div>

      <div class="contact-panel-shell">
        <div class="contact-panel">
          <div class="contact-panel-left">
            <div class="contact-block">
              <div class="contact-block-title-row">
                <span class="contact-icon contact-icon--pin" aria-hidden="true">
                 <img :src="require('@/assets/adress1.png')" alt="" class="contact-icon-img1" />
                </span>
                <div>
                  <h3 class="contact-block-title">{{ $t('home.contactAddressTitle') }}</h3>
                  <p class="contact-block-text" v-html="$t('home.contactAddressText')"></p>
                </div>
               
              </div>
             
              <div class="contact-sep" aria-hidden="true">
                <span class="contact-sep-blue" />
                <span class="contact-sep-gray" />
              </div>
            </div>

            <div class="contact-block contact-block--last">
              <div class="contact-block-title-row">
                <span class="contact-icon contact-icon--mail" aria-hidden="true">
                  <img :src="require('@/assets/email1.png')" alt="" class="contact-icon-img2" />
                </span>
                <div>
                  <h3 class="contact-block-title">{{ $t('home.contactEmailTitle') }}</h3>
                  <p class="contact-block-text">SERVICE@SHANGYINXINSHENG.COM
                    
                  </p>
                </div>
               
              </div>
            
              <div class="contact-sep" aria-hidden="true">
                <span class="contact-sep-blue" />
                <span class="contact-sep-gray" />
              </div>
            </div>
          </div>

          <div class="contact-panel-right">
            <div class="contact-person-wrap">
              <div class="contact-person-blob" aria-hidden="true" />
              <img
                :src="require('@/assets/kf.png')"
                alt=""
                class="contact-person-img"
                width="552"
                height="528"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import HeroCarousel from '@/components/HeroCarousel.vue'
import ProductCategorySection from '@/components/ProductCategorySection.vue'

export default {
  name: 'Home',
  components: { HeroCarousel, ProductCategorySection },
  data() {
    const placeholderImg = require('@/assets/logo.png')
    return {
      selectedCategoryId: '',
      selectedPopularId: '1',
      placeholderImg,
      aboutImg1: placeholderImg,
      contactBgImg: require('@/assets/banner1-2.png'),
      contactPersonImg: require('@/assets/logo.png'),
    }
  },
  methods: {
    selectedPopular(id) {
      this.selectedPopularId = id;
      this.$router.push(`/detail/${id}`);
    },
  },
}
</script>

<style scoped>
.page {
  background: #EDEDED;
  min-height: 100vh;
}

#category,
#popular,
#about,
#about-b2,
#contact {
  scroll-margin-top: 80px;
}

/* Popular product block */
.popular-hot-icon-img {
width: 27px;
height: 32px;
}
.popular-section {
  margin-top: 94px;
  --popular-blue:#4375C6;
  background: var(--popular-blue);
  margin: 94px auto 0;
  padding: 40px 24px 48px;
}

.popular-inner {
  max-width: 1570px;
  margin: 0 auto;
}

.popular-line-wrap{
  display: flex;
 padding-top: 40px;
  margin-bottom: 36px;
}
.popular-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.popular-hot-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  flex-shrink: 0;
}

.popular-hot-flame {
  width: 40px;
  height: 40px;
  display: block;
}

.popular-hot-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  line-height: 1;
}

.popular-title {
  margin: 0;
  font-weight: bold;
font-size: 31px;
color: #FFFFFF;
line-height: 27px;
  letter-spacing: 0.06em;
  color: #fff;
  text-transform: uppercase;
}

.popular-accent-line {
  width: 120px;
  max-width: 40%;
  height: 4px;
  background: #fff;
  border-radius: 1px;
  margin-bottom: 10px;
}

.popular-rule-line {
  height: 4px;
  background: #EDEDED;
  width: 100%;
  margin-bottom: 28px;
  opacity: 0.5;
}

.popular-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 48px;
}

.popular-card {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  display: block;
}

.popular-card-img-wrap {
  background: #fff;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.popular-card-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.35s ease, filter 0.35s ease;
}

.popular-card:hover .popular-card-img {
  transform: scale(1.06);
  filter: brightness(1.05);
}

.popular-card-label {
  background: #e8eaee;
  font-weight: 400;
font-size: 27px;
color: #454545;
line-height: 23px;
text-align: center;
font-style: normal;
text-transform: none;
  padding: 14px 10px;
  line-height: 1.35;
  transition: color 0.2s ease;
}

.popular-card-img-wrap:hover ~ .popular-card-label {
  color: #2563eb;
}
@media (max-width: 900px) {
  .popular-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .popular-grid {
    grid-template-columns: 1fr;
  }

  .popular-card-label {
    font-size: 12px;
    padding: 12px 8px;
  }
}

.about-section {
background: #EDEDED;
}
.about-section-white{
  background: #fff;
}
.about-outer {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  padding: 48px 24px 56px;
  box-sizing: border-box;
}

.about-inner {
  max-width: 1570px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.about-header {
  margin-bottom: 36px;
}

.about-heading {
  margin: 0 0 14px;
  font-weight: bold;
font-size: 38px;
color: #282828;
line-height: 33px;
text-align: left;
font-style: normal;
text-transform: none;
}

.about-title-rule {
  margin-top: 46px;
  display: flex;
  height: 4px;
  width: 100%;
  max-width: 223px;
  border-radius: 2px;
  overflow: hidden;
}

.about-title-rule-blue {
  width:40%;
  background: #3b71ca;
}

.about-title-rule-gray {
  flex: 1;
  background: #e0e0e0;
}

.about-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  margin-bottom: 40px;
}

.about-text {
  flex: 1 1 68%;
  min-width: 0;
  max-width: 68%;
}

.about-p {
  margin: 0;
  font-size: 25px;
  line-height: 2;
  letter-spacing: 0.02em;
  color: #333;
  text-align: justify;
}

.about-b3-p {
  display: inline;
  font-size: 25px;
  color: #3b71ca;
  font-weight: 500;
  line-height: 2;
}
.about-highlight {
  display: inline;
  font-size: 25px;
  color: #3b71ca;
  font-weight: 500;
}

.about-b3-highlight {
  font-weight: 400;
  margin: 0;
  font-size: 25px;
  line-height: 2;
  letter-spacing: 0.02em;
  color: #333;
  text-align: justify;
}
.about-figure {
  flex: 1 1 32%;
  min-width: 0;
  max-width: 32%;
}
.about-figure-left{
   min-width: 0;
  max-width: 32%;
}
.about-block-img {
  display: block;
  width: 75.5%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
}

.about-bottom-rule {
  display: flex;
  height: 4px;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
}

.about-bottom-rule-blue {
  width: 15%;
  background: #3b71ca;
}

.about-bottom-rule-gray {
  width: 77.5%;
  background:#EDEDED;
}
.about-bottom-rule-white {
  width: 77.5%;
  background: #fff;
}
@media (max-width: 900px) {
  .about-main {
    flex-direction: column;
    align-items: stretch;
  }

  .about-text,
  .about-figure {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .about-figure {
    order: -1;
  }

  .about-block-img {
    max-height: 260px;
  }

  .about-p {
    font-size: 15px;
  }
}

.about-b2-section {
  background: #fff;
}

.about-b2-outer {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  background: #fff;
  padding: 48px 24px 56px;
  box-sizing: border-box;
}

.about-b2-inner {
  max-width: 1570px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.about-b2-main {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 40px;
}

.about-b2-figure {
  flex: 1 1 32%;
  min-width: 0;
  max-width: 32%;
}

.about-b2-img {
  display: block;
  width: 76.5%;
  height: auto;
  max-height: 420px;
  object-fit: cover;
  border-radius: 12px;
}

.about-b2-text {
  flex: 1 1 68%;
  min-width: 0;
  max-width: 68%;
  position: relative;
  right: 97px;
}

.about-b2-p {
  margin: 0;
  font-size: 24px;
  line-height: 1.75;
  color: #333;
  text-align: justify;
}

.about-b2-highlight {
  color: #4a90e2;
  font-size: 25px;
  font-weight: 600;
}

.about-b2-bottom-rule {
  display: flex;
  height: 4px;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
}

.about-b2-bottom-rule-blue {
  width: 32%;
  background: #4a90e2;
}

.about-b2-bottom-rule-gray {
  flex: 1;
  background: #e0e0e0;
}

@media (max-width: 900px) {
  .about-b2-main {
    flex-direction: column;
  }

  .about-b2-text,
  .about-b2-figure {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .about-b2-figure {
    order: -1;
  }

  .about-b2-img {
    max-height: 280px;
  }

  .about-b2-p {
    font-size: 15px;
  }
}

/* .contact-footer {
  position: relative;
  top: 157px;
  margin: 0 ;
  background: #EDEDED;
  max-width: none;
} */

.contact-footer-bg {
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 420px;
}
.contact-icon-img1{
  width: 52px;
  height: 50px;
  position: relative;
  bottom: 15px;
}
.contact-icon-img2{
  width: 51px;
  height: 51px;
}
.contact-bg-top {
  position: relative;
  min-height: 220px;
  flex: 0 0 45%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.contact-bg-top::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(30, 64, 175, 0.42) 0%,
    rgba(15, 23, 42, 0.5) 100%
  );
  pointer-events: none;
}

.contact-bg-bottom {
  flex: 1;
  min-height: 200px;
  background: #e8eaee;
}

.contact-panel-shell {
  position: relative;
    z-index: 10;
    bottom: 150px;
    margin: 0 auto;
  padding: 0 24px 32px;
  max-width: 1920px;
}

.contact-panel {
  max-width: 1570px;
  margin: 0 auto;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 48px rgba(15, 23, 42, 0.12);
  padding: 48px 200px 52px 140px ;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 40px 56px;
  align-items: center;
  box-sizing: border-box;
}

.contact-panel-left {
  min-width: 0;
}

.contact-block {
  margin-bottom: 80px;
}

.contact-block--last {
  margin-bottom: 0;
}

.contact-block-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.contact-icon {
  flex-shrink: 0;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-icon--pin svg {
  width: 28px;
  height: 28px;
}

.contact-icon--mail svg {
  width: 32px;
  height: 32px;
}

.contact-block-title {
  font-weight: bold;
font-size: 26px;
color: #4375C6;
line-height: 0;
text-align: left;
font-style: normal;
text-transform: none;
}

.contact-block-text {
  margin: 0 0 16px;
  font-size: 18px;
  line-height: normal;
  letter-spacing: 0.04em;
  color: #666;
  text-transform: uppercase;
}

.contact-sep {
  display: flex;
  height: 4px;
  width: 100%;
  max-width: 627px;
  border-radius: 2px;
  overflow: hidden;
}

.contact-sep-blue {
  width: 18%;
  background: #2563eb;
}

.contact-sep-gray {
  flex: 1;
  background: #ddd;
}

.contact-panel-right {
  flex-shrink: 0;
}

.contact-person-wrap {
  position: relative;
  width: 552px;
  max-width: 100%;
  height: 528px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.contact-person-blob {
  position: absolute;
  right: 8%;
  bottom: 8%;
  width: 72%;
  height: 78%;
  background: linear-gradient(145deg, #dbeafe 0%, #bfdbfe 100%);
  border-radius: 28px;
  z-index: 0;
}

.contact-person-img {
  position: relative;
  z-index: 1;
  width: 552px;
  max-width: 100%;
  height: auto;
  max-height: 528px;
  object-fit: contain;
  filter: drop-shadow(0 12px 28px rgba(15, 23, 42, 0.15));
}

.contact-copyright {
  max-width: 1920px;
  margin: 0 auto;
  padding: 28px 24px 36px;
  text-align: center;
  font-size: 14px;
  color: #777;
  background: #e8eaee;
}

@media (max-width: 1100px) {
  .contact-panel {
    grid-template-columns: 1fr;
    padding: 36px 28px 40px;
  }

  .contact-panel-right {
    justify-self: center;
  }

  .contact-person-wrap {
    height: auto;
    min-height: 280px;
  }

  .contact-person-img {
    width: min(552px, 100%);
  }
}
</style>

